
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trial/mint",
      function () {
        return require("private-next-pages/trial/mint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trial/mint"])
      });
    }
  